module.exports = __webpack_public_path__ + "fonts/MullerBlackItalic.f3832d90.ttf";